import { AttributeValueEditors, Attributes } from '@leverege/ui-attributes';
import { useEffect } from 'react';
export default function KeyWarrantyLengthEditor(props) {
  const {
    onChange,
    value,
    eventData
  } = props;
  useEffect(() => {
    onChange({
      data: 'warrantyLength',
      value: '36'
    });
  }, []);
  const attr = Attributes.getAttribute('sale.keysWarranty.warrantyLength', 'sale');
  return AttributeValueEditors.getEditorFor('sale.keysWarranty.warrantyLength', 'sale')?.create({
    // Used by all editors.
    attribute: attr,
    onChange,
    value,
    eventData,
    disabled: false,
    autoFocus: false,
    editable: true,
    object: {
      id: 'saleId',
      type: 'sale',
      ref: 'systemId/sale'
    }
  }) || null;
}